import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_VOLOP_REFINEMENT_LABELS } from 'modules/search/constants/refinements/searchVolopRefinementTypes';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';
import { VOLOP_SOURCE_CHECKBOX_OPTIONS } from 'utils/constants/general/volopSources';

type Props = {
  variant?: SearchRefinementVariant;
};

export function VolopSourceFacet({ variant = 'dropdown' }: Props) {
  const selectedFacetValues = useSearchFacetSelectedValues('source');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="source"
      icon="sign-path"
      label={
        <>
          {SEARCH_VOLOP_REFINEMENT_LABELS.source}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="source"
        initialValue={selectedFacetValues}
        searchable
        options={VOLOP_SOURCE_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
